import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.2426 14.2426l.7072.7071c-2.7337 2.7337-7.1659 2.7337-9.8996 0-2.7336-2.7336-2.7336-7.1658 0-9.8995l.7072.7071c-2.3394 2.3394-2.3394 6.1459 0 8.4853 2.3393 2.3394 6.1459 2.3394 8.4852 0zM24 21c0 1.6569-1.3431 3-3 3l-5.5919-5.5919c-3.8724 2.4958-9.089 2.053-12.4791-1.337-3.9053-3.9053-3.9053-10.237 0-14.1422 3.9052-3.9052 10.2368-3.9052 14.142 0 3.3902 3.3901 3.833 8.6068 1.3371 12.4792L24 21zm-7.636-4.636c3.509-3.5091 3.509-9.2189 0-12.728S7.145.127 3.636 3.636s-3.509 9.2189 0 12.728 9.2189 3.509 12.728 0zm6.6001 5.0143l-5.1473-5.1473c-.2315.2897-.4774.5717-.7458.84-.2683.2685-.5503.5143-.84.7458l5.1474 5.1473c.8-.1538 1.432-.7858 1.5857-1.5858z',
  ],
  height: 24,
  width: 24,
});
